module.exports = __webpack_public_path__ + "img/main-blolb.03ccf7db.png";